<template>
  <modal-dialog
    :visible="dialog"
    persistent
    scrollable
    max-width="600px"
    :title="$t('title.settings')"
  >
    <!-- Body -->
    <v-form ref="form">
      <v-row>
        <v-col
          cols="6"
          class="pb-0 mb-0"
        >
          <v-select
            v-model="hs.minimumPartySize"
            :items="partySizeList"
            clearable
            :label="$t('label.min_party_size')"
          />
        </v-col>
        <v-col
          cols="6"
          class="pb-0 mb-0"
        >
          <v-select
            v-model="hs.maximumPartySize"
            :items="partySizeList"
            clearable
            :label="$t('label.max_party_size')"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="6"
          class="pb-0 mb-0"
        >
          <v-select
            v-model="hs.maximumGuests"
            :items="partySizeList"
            clearable
            :label="$t('label.max_guests_per_time')"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
          class="pb-0 mb-0"
        >
          <v-select
            v-model="hs.maximumReservations"
            :items="partySizeList"
            clearable
            :label="$t('label.max_reservations_per_time')"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="6"
          class="pb-0 mb-0"
        >
          <v-select
            v-model="hs.fixedEndingInMinutes"
            :items="endingTimeList"
            clearable
            :label="$t('label.fixed_ending_time_min')"
          />
        </v-col>
      </v-row>
    </v-form>
    <!-- Actions -->
    <template #actions>
      <v-spacer />
      <v-btn
        color="success"
        :disabled="!isChanged"
        @click="save"
      >
        {{ $t('button.save') }}
      </v-btn>
      <v-btn
        color="error"
        text
        @click="cancel"
      >
        {{ $t('button.cancel') }}
      </v-btn>
    </template>
  </modal-dialog>
</template>

<script lang="ts">
import Vue from 'vue';
import DialogClosable from '@/mixins/dialog-closable';
import HourSlot from '@/model/HourSlot';

export default Vue.extend({
  mixins: [DialogClosable],
  data() {
    return {
      partySizeList: [...new Array(500)].map((e, i) => (i + 1)),
      endingTimeList: [...new Array(24)].map((e, i) => ((i + 1) * 15)),
      hs: new HourSlot(),
    };
  },
  computed: {
    isChanged(): boolean {
      return this.hs.isCustom;
    },
  },
  mounted() {
  },
  methods: {
    close() {
      (this.$refs.form as Vue & { reset: () => void }).reset();
      this.$emit('close');
    },
    cancel() {
      this.close();
    },
    save() {
      this.$emit('save-result', this.hs);
      this.close();
    },
  },
});
</script>
